module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki12_sp-b5164b9dfd20d25858298829eebbd311.jpg";